import { render, staticRenderFns } from "./MVsDetail.vue?vue&type=template&id=68a0f3f6&scoped=true&"
import script from "./MVsDetail.vue?vue&type=script&lang=js&"
export * from "./MVsDetail.vue?vue&type=script&lang=js&"
import style0 from "./MVsDetail.vue?vue&type=style&index=0&id=68a0f3f6&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68a0f3f6",
  null
  
)

export default component.exports